"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnchorManager = void 0;
var AnchorManager = /** @class */ (function () {
    function AnchorManager() {
        var _this = this;
        this._currentAnchor = window.location.hash;
        this._timer = setInterval(function () {
            if (_this._currentAnchor !== window.location.hash) {
                clearInterval(_this._timer);
                window.location.reload();
            }
        }, 100);
    }
    AnchorManager.prototype.setAnchor = function (anchor) {
        if (window.location.hash.trim() == '' || window.location.hash == '#') {
            window.location.hash = anchor;
        }
        else {
            window.location.replace(anchor);
        }
        this._currentAnchor = window.location.hash;
    };
    return AnchorManager;
}());
exports.AnchorManager = AnchorManager;
